export enum TrackingEvents {}

export enum DATADOG_EVENT_NAMES {
    ERROR_PAGE_SHOWN = 'Error page shown',
    START_SESSION = 'Start session',
}

export const RUDDERSTACK_TRACKED_EVENTS = [];
